<template>
  <div class="page-wrapper">
    <MusicPage @tab="switchTab" v-if="tab_switch == 'music'"></MusicPage>
    <MoviesPage @tab="switchTab" v-if="tab_switch == 'movies'"></MoviesPage>
    <EducationPage @tab="switchTab" v-if="tab_switch == 'education'"></EducationPage>
    <PodcastPage @tab="switchTab" v-if="tab_switch == 'podcast'"></PodcastPage>
    <OthersPage @tab="switchTab" v-if="tab_switch == 'others'"></OthersPage>
    <PlaylistPage @tab="switchTab" v-if="tab_switch == 'playlist'"></PlaylistPage>
    <UploadedPage @tab="switchTab" v-if="tab_switch == 'uploaded'"></UploadedPage>
  </div>
</template>
<script>
import MusicPage from "./MusicPage.vue";
import MoviesPage from './MoviesPage.vue';
import EducationPage from './EducationPage.vue';
import PodcastPage from './PodcastPage.vue';
import OthersPage from './OtherPage.vue';
import PlaylistPage from './PlaylistPage.vue';
import UploadedPage from './UploadedPage.vue';
export default {
  components: {
    MusicPage, MoviesPage, EducationPage, PodcastPage, OthersPage, PlaylistPage, UploadedPage
  },
  data: () => ({
    tab_switch: "music",
  }),
  watch: {
    "$route.params.tab"(tab) {
      if (tab) {
        this.tab_switch = tab;
      } else {
        this.tab_switch = "music";
      }
    },
  },
  mounted() {
    let vm = this;
    if (vm.$route.params.tab) {
      vm.tab_switch = vm.$route.params.tab;
    }
  },
  methods: {
    switchTab(tab) {
      let vm = this;
      vm.tab_switch = tab;
      vm.$router.push({ name: "s_audiov", params: { tab: tab } });
    },
  },
};
</script>
<style lang="scss" scoped>
.page-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
</style>
